import React, { createContext, useCallback, useContext, useState } from 'react';

interface ChangeContextProps {
  isDirty: boolean;
  markDirty: () => void;
  resetDirty: () => void;
}
const ChangeContext = createContext<ChangeContextProps | null>(null);

export const useChangeTracker = () => {
  const ctx = useContext(ChangeContext);
  if (!ctx) throw new Error('ChangeContext not found');
  return ctx;
};

export const ChangeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isDirty, setIsDirty] = useState(false);
  const markDirty = useCallback(() => setIsDirty(true), []);
  const resetDirty = useCallback(() => setIsDirty(false), []);
  return (
    <ChangeContext.Provider value={{ isDirty, markDirty, resetDirty }}>
      {children}
    </ChangeContext.Provider>
  );
};
